module.exports = __webpack_public_path__ + "img/fashion_80.167df15a.jpg";